import { useEffect, useRef, useState } from "react";
export const useCollapse = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [height, setHeight] = useState("0px")
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current
    if (ref.current) {
      setHeight(isOpen ? `${ref.current.scrollHeight}px`: "0px");
      if (isOpen) {
        ref.current?.addEventListener("transitionend", transitionend);
      }
    }
    return () => {
      el?.removeEventListener("transitionend", transitionend);
    }
  }, [isOpen]);
  function transitionend() {
    const rect = ref.current.getBoundingClientRect();
    const bottom = rect.bottom; // 元素底部相对视口位置
    const viewportHeight = window.innerHeight;

    if (bottom > viewportHeight) {
      // 滚动距离 = 当前滚动 + 超出的部分
      const scrollBy = bottom - viewportHeight + window.scrollY + 10; // +10px 缓冲
      window.scrollTo({ top: scrollBy, behavior: "smooth" });
    }
  }
  return { isOpen, setIsOpen, height, ref }
}